import {
  getDatabase,
  ref,
  get,
  remove,
  update,
  runTransaction,
} from "firebase/database";
import { getServerTime } from "./userService";
import {
  getHorarioResetList,
  getLimitePresenca,
  getModoDevReset,
} from "./memory";

function getWeekId(date: Date) {
  const janFirst = new Date(date.getFullYear(), 0, 1);
  const days = Math.floor((date.getTime() - janFirst.getTime()) / 86400000);
  const week = Math.ceil((date.getDay() + 1 + days) / 7);
  return `${date.getFullYear()}-${week}`;
}

export const resetList = async () => {
  try {
    const db = getDatabase();
    const timestamp = await getServerTime();
    let now;

    if (getModoDevReset()) {
      // MODO DEV → usar quarta-feira falsa
      const today = new Date();
      const year = today.getUTCFullYear();
      const month = today.getUTCMonth(); // 0 = Janeiro, 11 = Dezembro

      // Encontrar a primeira quarta-feira do mês atual
      let day = 1;
      while (new Date(Date.UTC(year, month, day)).getUTCDay() !== 3) {
        day++;
      }

      // Define a hora como 10:00 UTC
      now = new Date(Date.UTC(year, month, day, 10, 0, 0));
    } else {
      // MODO PRODUÇÃO → usar timestamp real do servidor
      now = new Date(timestamp);
    }

    const dia = now.getDay();
    const hora = now.getHours();
    const minutos = now.getMinutes();
    const horaMinuto = hora * 100 + minutos;

    const isAfterTerca22h = dia === 2 && horaMinuto >= getHorarioResetList();
    const isBeforeSegunda12h = dia === 1 && horaMinuto <= 1258;
    const isEntrePeriodoReset =
      isAfterTerca22h ||
      dia === 3 ||
      dia === 4 ||
      dia === 5 ||
      dia === 6 ||
      dia === 0 ||
      isBeforeSegunda12h;

    if (!isEntrePeriodoReset) return;

    const semanaAtual = getWeekId(now);
    const configRef = ref(db, "config/ultimoResetSemanal");

    const result = await runTransaction(configRef, (ultimoReset) => {
      if (ultimoReset === semanaAtual) return;
      return semanaAtual;
    });

    if (!result.committed) {
      console.log("⏭️ Reset já realizado nesta semana. Abortando.");
      return;
    }

    const presencaSnap = await get(ref(db, "presenca"));
    const presenca = presencaSnap.val() || {};

    const entries = Object.entries(presenca).map(
      ([uid, entry]: [string, any]) => {
        const inscricaoDate = new Date(entry.timestamp);
        return {
          uid,
          timestamp: entry.timestamp,
          rawTime: inscricaoDate.getTime(),
          numberOfGames: entry.totalJogos || 0,
          isTuesday: entry.isTuesday || false,
        };
      }
    );

    const segundaFeira = entries.filter((e) => !e.isTuesday);
    const tercaFeira = entries.filter((e) => e.isTuesday);

    const ordenados = [
      ...segundaFeira.sort((a, b) => {
        if (a.numberOfGames !== b.numberOfGames) {
          return a.numberOfGames - b.numberOfGames;
        }
        return a.rawTime - b.rawTime;
      }),
      ...tercaFeira.sort((a, b) => a.rawTime - b.rawTime),
    ];

    const uidsJogaram = ordenados
      .slice(0, getLimitePresenca())
      .map((entry) => entry.uid);
    const uidsNaoJogaram = ordenados
      .slice(getLimitePresenca())
      .map((entry) => entry.uid);
    const updates: { [path: string]: any } = {};
    const usersSnap = await get(ref(db, "users"));
    const users = usersSnap.val() || {};
    // Zera campos temporários de todos os usuários
    for (const uid in users) {
      updates[`users/${uid}/jogoContabilizado`] = false;
      updates[`users/${uid}/isTuesday`] = false;
      updates[`users/${uid}/penalidadeJogo`] = false;
    }
    await Promise.all(
      ordenados.map(async (entry) => {
        const userSnap = await get(ref(db, `users/${entry.uid}`));
        const userData = userSnap.val();
        const jogosAnual = userData?.jogosAnual || 0;

        // Só atualiza jogos se estiver dentro do limite de vagas
        if (uidsJogaram.includes(entry.uid)) {
          updates[`users/${entry.uid}/jogosAnual`] = jogosAnual + 1;
        }

        if (uidsNaoJogaram.includes(entry.uid)) {
          const totalJogos = userData?.totalJogos || 0;
          if (totalJogos > 0) {
            updates[`users/${entry.uid}/totalJogos`] = totalJogos - 1;
          }
        }
      })
    );

    // Salva a lista atual antes de apagar
    updates["presencahistorico"] = presenca;
    await update(ref(db), updates);
    await remove(ref(db, "presenca"));

    console.log(
      "✅ Lista resetada com ordem correta e jogosAnual atualizados."
    );
  } catch (error) {
    console.error("Erro ao resetar a lista:", error);
  }
};
